// FormFooter — Presentational error message block plus the "Clear" and
// "Create Trip" action buttons. The submit button is `type="submit"` (no
// onClick) so the parent <form>'s onSubmit drives creation.
//
// Extracted VERBATIM from `components/ManualTripCreator.js` (behavior-preserving
// refactor, issue #240). Render-only, wrapped in React.memo. Markup, styles,
// hover handlers, and the "Creating Trip..." label toggle are identical to the
// source.
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';
import { Plus } from 'lucide-react';

export const FormFooter = React.memo(function FormFooter({ error, isCreating, onReset }) {
  return (
    <>
      {/* Error Message */}
      {error && (
        <div style={{
          padding: '12px',
          background: '#fef2f2',
          border: '1px solid #fecaca',
          borderRadius: '8px',
          color: '#dc2626',
          fontSize: '14px',
          marginBottom: '20px'
        }}>
          {error}
        </div>
      )}

      {/* Action Buttons */}
      <div style={{
        display: 'flex',
        gap: '12px',
        justifyContent: 'flex-end'
      }}>
        <button
          type="button"
          onClick={onReset}
          disabled={isCreating}
          style={{
            padding: '12px 24px',
            fontSize: '14px',
            fontWeight: '500',
            color: '#6b7280',
            background: 'white',
            border: '1px solid #d1d5db',
            borderRadius: '8px',
            cursor: isCreating ? 'not-allowed' : 'pointer',
            opacity: isCreating ? 0.5 : 1,
            transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => {
            if (!isCreating) {
              e.target.style.background = '#f9fafb';
            }
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'white';
          }}
        >
          Clear
        </button>
        
        <button
          type="submit"
          disabled={isCreating}
          style={{
            padding: '12px 24px',
            fontSize: '14px',
            fontWeight: '500',
            color: 'white',
            background: isCreating ? '#6b7280' : '#0ea5e9',
            border: 'none',
            borderRadius: '8px',
            cursor: isCreating ? 'not-allowed' : 'pointer',
            transition: 'background 0.2s',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          onMouseEnter={(e) => {
            if (!isCreating) {
              e.target.style.background = '#0284c7';
            }
          }}
          onMouseLeave={(e) => {
            if (!isCreating) {
              e.target.style.background = '#0ea5e9';
            }
          }}
        >
          <Plus size={16} />
          {isCreating ? 'Creating Trip...' : 'Create Trip'}
        </button>
      </div>
    </>
  );
});

export default FormFooter;
